import styles from "./TitleWithLine.module.scss";

function TitleWithLine({ text, color }) {
  return (
    <div className={styles.container}>
      <div className={styles.line} style={{ backgroundColor: color }}></div>
      <div className={styles.text} style={{ color }}>
        {text}
      </div>
      <div className={styles.line} style={{ backgroundColor: color }}></div>
    </div>
  );
}

export default TitleWithLine;
